<a
  class="tt-header_logo"
  [class.tt-header_logo--disabled]="!isStartedOnlineAndCurrentlyOnline()"
  [routerLink]="isStartedOnlineAndCurrentlyOnline() ? '/' : null"
  ><mat-icon [icon]="'logo'" [iconSize]="32"
/></a>

<div class="tt-header_menu">
  @if (showDashboardInsteadOfMenu()) {
    <mat-icon [icon]="'logo'" [iconSize]="32" [routerLink]="'/'" />
  } @else {
    @if (smartbookSidebarService.isOpen()) {
      <mat-icon [icon]="'x'" [iconSize]="24" (click)="smartbookSidebarService.setSidebar(false)" />
    } @else {
      <mat-icon [icon]="'menu'" [iconSize]="24" (click)="smartbookSidebarService.setSidebar(true)" />
    }
  }
</div>

@if (isQaEnvironment && isMobileService.isMobile()) {
  <div class="tt-header_qa-banner tt-header_qa-banner--mobile">{{ 'QA' | transloco }}</div>
}

@if (navShellService.sideNavState()) {
  <nav class="tt-header_navigation">
    <a
      *ngxPermissionsOnly="permissions.viewDashboardPage"
      class="tt-header_navigation-btn"
      routerLink="/smartbook"
      routerLinkActive="active"
    >
      <span class="tt-header_navigation-btn-text" data-testid="header_button-dashboard">{{
        'Header.Smartbook' | transloco
      }}</span>
    </a>

    @if (isStartedOnlineAndCurrentlyOnline()) {
      @if (licenseService.licensedFeatures().guidelineEditor) {
        <a
          *ngxPermissionsOnly="[permissions.viewManagePage, permissions.viewReviewPage, permissions.editGuideline]"
          class="tt-header_navigation-btn"
          routerLinkActive="active"
          [class.tt-header_navigation-btn--disabled]="!isStartedOnlineAndCurrentlyOnline()"
          [routerLink]="isStartedOnlineAndCurrentlyOnline() ? '/manage' : null"
        >
          <span class="tt-header_navigation-btn-text" data-testid="header_button-manage">{{
            'Header.Manage' | transloco
          }}</span>
        </a>
      }
      @if (licenseService.licensedFeatures().statistics) {
        <a
          *ngxPermissionsOnly="permissions.viewStatistics"
          class="tt-header_navigation-btn"
          routerLinkActive="active"
          [class.tt-header_navigation-btn--disabled]="!isStartedOnlineAndCurrentlyOnline()"
          [routerLink]="isStartedOnlineAndCurrentlyOnline() ? '/statistics' : null"
          (click)="onStatisticsClick()"
        >
          <span class="tt-header_navigation-btn-text" data-testid="header_button-statistics">{{
            'Header.Statistics' | transloco
          }}</span>
        </a>
      }
      <a
        *ngxPermissionsOnly="permissions.viewSharePage"
        class="tt-header_navigation-btn"
        routerLinkActive="active"
        [class.tt-header_navigation-btn--disabled]="!isStartedOnlineAndCurrentlyOnline()"
        [routerLink]="isStartedOnlineAndCurrentlyOnline() ? '/share' : null"
      >
        <span class="tt-header_navigation-btn-text" data-testid="header_button-share">{{
          'Header.Share' | transloco
        }}</span>
      </a>

      @if (!!TreetopPropertiesProvider.properties.hubUrl && permissionResolverService.isAllowedToViewHubInHeader()) {
        @if (isStartedOnlineAndCurrentlyOnline()) {
          <a
            class="tt-header_navigation-btn"
            href="{{ TreetopPropertiesProvider.properties.hubUrl }}"
            target="_blank"
            [class.tt-header_navigation-btn--disabled]="!isStartedOnlineAndCurrentlyOnline()"
            (click)="onHubClick()"
          >
            <span class="tt-header_navigation-btn-text">{{ 'Header.Hub' | transloco }}</span>
          </a>
        } @else {
          <a class="tt-header_navigation-btn tt-header_navigation-btn--disabled">
            <span class="tt-header_navigation-btn-text">{{ 'Header.Hub' | transloco }}</span>
          </a>
        }
      }

      <a
        *ngxPermissionsOnly="permissions.viewComponents"
        class="tt-header_navigation-btn"
        routerLink="/admin/components"
        routerLinkActive="active"
        [class.tt-header_navigation-btn--disabled]="!isStartedOnlineAndCurrentlyOnline()"
      >
        <span class="tt-header_navigation-btn-text">{{ 'Header.Components' | transloco }}</span>
      </a>
      <a
        *ngxPermissionsOnly="permissions.viewAllOrganisationStatistics"
        class="tt-header_navigation-btn"
        routerLink="/admin/statistics"
        routerLinkActive="active"
        [class.tt-header_navigation-btn--disabled]="!isStartedOnlineAndCurrentlyOnline()"
      >
        <span class="tt-header_navigation-btn-text">{{ 'Header.AdminStatistics' | transloco }}</span>
      </a>
      <a
        *ngxPermissionsOnly="permissions.copyGuidelines"
        [rou
        class="tt-header_navigation-btn"
        routerLink="/admin/administration"
        routerLinkActive="active"
        [class.tt-header_navigation-btn--disabled]="!isStartedOnlineAndCurrentlyOnline()"
      >
        <span class="tt-header_navigation-btn-text">{{ 'Header.Administration' | transloco }}</span>
      </a>
    }
  </nav>
}

@if (!isMobileService.isMobile()) {
  <div class="tt-header_placeholder"></div>
}

@if (isQaEnvironment && isMobileService.isDesktop()) {
  <div class="tt-header_qa-banner">
    {{ ('QAStage' | transloco) + ' - ' + ('Build' | transloco: { version: environmentVersion }) }}
  </div>
} @else if (isQaEnvironment && isMobileService.isTablet()) {
  <div class="tt-header_qa-banner">
    {{ 'QAStage' | transloco }}
  </div>
}

<tt-search [disabled]="!isStartedOnlineAndCurrentlyOnline()" [headerRef]="elementRef" />

@if (isStartedOnlineAndCurrentlyOnline()) {
  @if (syncingVm().offlineSyncEnabled) {
    <div class="tt-header_sync" [ttTooltip]="GuidelineSyncPopoverComponent">
      @if (syncingVm().syncing) {
        <mat-icon class="tt-header_sync-icon--in-progress" [icon]="'cloud-sync'" [iconSize]="20" />
        <div class="tt-header_sync-process">
          <div class="tt-header_sync-process-indicator" [style.width]="`${syncingVm().progress}%`"></div>
        </div>
      } @else {
        <mat-icon class="tt-header_sync-icon--done" [icon]="'cloud-check'" [iconSize]="20" />
      }
    </div>
  }

  @if (productFruitsService.ready()) {
    <button #helpCenterButton class="tt-header_help-center-button">
      @if (productFruitsService.inAppCenterIsOpened()) {
        <mat-icon [icon]="'x'" [iconSize]="24" />
      } @else {
        <mat-icon [icon]="'circle-question-mark'" [iconSize]="24" />
      }
    </button>
  }
}

<tt-user-info [disabled]="!isStartedOnlineAndCurrentlyOnline()" />
